/** Dedicated legal entity for Stripe Connect partner collections. */
export const PARTNER_COLLECTIONS_ENTITY_ID = 'ET01';

/** Dedicated ledger book for Stripe Connect partner collections. */
export const PARTNER_COLLECTIONS_ACCOUNT_ID = 'AC09';

/**
 * Temporary hardcode: cash collections always post to this ledger book.
 * Replace with office/config wiring later.
 */
export const CASH_COLLECTION_ACCOUNT_ID = 'AC10';

export const PARTNER_COLLECTIONS_PAGE_PATH = '/app/partner-collections';

export const PARTNER_COLLECTIONS_PAGE_LABEL = 'Partner Collections';
